/* eslint-disable camelcase */
import React from "react";
import { MoreVertical, Add } from "ceicons";
import "./pill.scss";

export default function Pill({ number, text, newItem, id }) {
  return (
    <div className={`pill ${newItem ? "new" : ""}`}>
      <span className="number">{number}</span>
      <span className="text">{text}</span>

      {newItem ? <Add /> : <MoreVertical />}
    </div>
  );
}
